import rightIconSrc from '@corbado/shared-ui/assets/right-arrow.svg';
import { memo, useRef } from 'react';
import React from 'react';
import { useIconWithTheme } from '../../../hooks/useIconWithTheme';
import { Icon } from './Icon';
export const RightIcon = memo(props => {
    const svgRef = useRef(null);
    const { logoSVG } = useIconWithTheme(svgRef, rightIconSrc);
    return (React.createElement(Icon, { src: logoSVG, ref: svgRef, alt: 'right-icon', ...props }));
});
